import React from "react";
import BookNewOrderNew from "./BookNewOrderNew";
import BookNewOrderOld from "./BookNewOrderOld";

const BookNewOrder = () => {
  const display = true;
  return (
    <div>
      <>{display ? <BookNewOrderOld /> : <BookNewOrderNew />}</>
    </div>
  );
};

export default BookNewOrder;
